import { stopEvaluation } from "legacy/actions/evaluationActions";
import { updateCurrentRoute } from "legacy/actions/pageActions";
import {
  ReduxActionErrorTypes,
  ReduxActionTypes,
} from "legacy/constants/ReduxActionConstants";
import { createImmerReducer } from "../createReducer";
import type { PageDSL8 } from "@superblocksteam/shared";

export interface AppViewReduxState {
  isInitialized: boolean;
  pageSwitchingError: boolean;
  dataAccessChangeError: boolean;
  dsl?: PageDSL8;
  currentLayoutId?: string;
}

const initialState: AppViewReduxState = {
  isInitialized: false,
  pageSwitchingError: false,
  dataAccessChangeError: false,
};

const appViewReducer = createImmerReducer(initialState, (builder) =>
  builder
    .addCase(stopEvaluation, () => initialState)
    // TODO(wylie): Use getSagaEvents helper once that doesn't cause a circular dependency
    .addCase("initializeAppViewerSaga/success", (state: AppViewReduxState) => {
      return { ...state, isInitialized: true };
    })
    .addCase("initializeAppViewerSaga/start", (state: AppViewReduxState) => {
      return { ...state, isInitialized: false, pageSwitchingError: false };
    })
    .addCase("initializeAppViewerSaga/error", (state: AppViewReduxState) => {
      return { ...state, isInitialized: true, pageSwitchingError: true };
    })
    .addCase(updateCurrentRoute.type, (state: AppViewReduxState) => {
      state.pageSwitchingError = false;
    })
    .addCase(
      ReduxActionErrorTypes.FETCH_PUBLISHED_PAGE_ERROR,
      (state: AppViewReduxState) => {
        state.pageSwitchingError = true;
      },
    )
    .addCase(
      ReduxActionTypes.SET_DATA_ACCESS_CHANGE_ERROR,
      (state: AppViewReduxState) => {
        state.dataAccessChangeError = true;
        state.isInitialized = true;
      },
    ),
);

export default appViewReducer;
